import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

interface IProps {
    children?: any[] | any
    verticalAlign?: boolean
}

export default function(props: IProps) {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                left: props.verticalAlign ? 0 : undefined,
                marginLeft: props.verticalAlign ? 15 : undefined,
                marginRight: props.verticalAlign ? 15 : undefined,
                position: props.verticalAlign ? 'absolute' : undefined,
                top: props.verticalAlign ? '50%' : undefined,
                transform: props.verticalAlign ? 'translate(0, -50%)' : undefined,
                width: props.verticalAlign ? 'calc(100% - 30px)' : undefined,
            }
        }),
    );

    const classes = useStyles();

    return (
        <div className={classes.root}>
            {props.children}
        </div>
    )
}
